@if (!httpError) {
  <div id="content-result" class="row">
    <div class="col-12">
      <div class="row">
        <h2 class="h-main h-main-medium corporate col-12">
          {{ 'result_title' | translate }}
        </h2>
        <div class="col-12">
          <div class="primary-info-box advanced-result mortgage-info">
            <div class="row date-row">
              <div class="col-7 text-align-left">
                <h3 class="amount">{{ 'result_mortgage_amount' | translate }}</h3>
              </div>
              <div class="col-5 text-align-right">
                @if (personalData?.level1Data?.mortgageAmount) {
                  <h3 id="rsult-mortgageAmount" class="amount nowrap">
                    {{ personalData.level1Data.mortgageAmount | number: '1.0-0' }}
                    €
                  </h3>
                }
              </div>
            </div>
            <div class="row date-row">
              <div class="col-8 text-align-left">
                <span>{{ 'result_financing_percentage' | translate }}</span>
              </div>

              @if (dataSimulate?.mortgageResult?.calculation?.ltv) {
                <div class="col-4 text-align-right">
                  <span id="result-ltv">
                    {{ dataSimulate?.mortgageResult?.calculation?.ltv * 100 | number: '1.2-2' }}
                    %</span
                  >
                </div>
              }
            </div>
            <div class="row date-row">
              <div class="col-8 text-align-left">
                <span>{{ 'result_duration_in_years' | translate }}</span>
              </div>
              <div class="col-4 text-align-right">
                <span id="result-termInYears">
                  {{ personalData?.level1Data?.termInYears }}
                  {{ 'label_years_mortgage_product_postpone' | translate }}</span
                >
              </div>
            </div>
            @if (dataSimulate?.mortgageResult?.params?.numMonthsFixed !== '0') {
              <div class="row date-row">
                <div class="col-8 text-align-left">
                  <span class="amount cuote">
                    {{
                      'result_monthly_fee_n_months'
                        | translate
                          : {
                              months: dataSimulate?.mortgageResult?.params?.numMonthsFixed
                                ? dataSimulate?.mortgageResult?.params?.numMonthsFixed
                                : '-',
                            }
                    }}
                  </span>
                  <a
                    class="icon-a"
                    href="javascript:void(0)"
                    tooltipEvent="focus"
                    appOpenToast
                    id="result-tooltip-first-year-monthly-fee"
                    [pTooltip]="
                      'simulation_result_tooltip_first_n_month_monthly_fee'
                        | translate
                          : {
                              months: dataSimulate?.mortgageResult?.params?.numMonthsFixed
                                ? dataSimulate?.mortgageResult?.params?.numMonthsFixed
                                : '-',
                            }
                    "
                  >
                    <img class="ico-info" src="assets/img/info.svg" />
                  </a>
                </div>
                <div class="col-4 text-align-right">
                  @if (dataSimulate?.mortgageResult?.calculation?.monthlyFeeY1) {
                    <span id="result-monthlyFeeY1" class="amount cuote nowrap">
                      {{ dataSimulate?.mortgageResult?.calculation?.monthlyFeeY1 | number: '1.2-2' }}
                      €</span
                    >
                  }
                </div>
              </div>
            }
            <div class="row date-row">
              <div class="col-8 text-align-left">
                <span class="amount cuote">{{
                  (dataSimulate?.mortgageResult?.params?.numMonthsFixed === '0'
                    ? 'result_monthly_fee_other_years_fee_0_months'
                    : 'result_monthly_fee_other_years'
                  ) | translate
                }}</span>
              </div>
              <div class="col-4 text-align-right">
                @if (dataSimulate?.mortgageResult?.calculation?.monthlyFee) {
                  <span id="result-monthlyFee" class="amount cuote nowrap"
                    >{{ dataSimulate?.mortgageResult?.calculation?.monthlyFee | number: '1.2-2' }} €</span
                  >
                }
              </div>
            </div>
            <div class="row date-row">
              <div class="col-6 order-md-first text-align-left">
                <h3 id="result-btn-modal-taxes" class="h-sub-section">
                  <span
                    >{{ 'result_taxes' | translate }}
                    <a class="btn btn-03" (click)="openModal('taxes')">{{
                      'result_btn_show_taxes' | translate
                    }}</a></span
                  >
                </h3>
              </div>
              <div class="col-6 text-align-right">
                @if (totalExpenses >= 0) {
                  <span id="result-totalExpenses">{{ totalExpenses | number: '1.2-2' }} € </span>
                }
              </div>
            </div>
            <div class="row">
              @if (!!dataSimulate?.result) {
                <div class="col-12" [ngSwitch]="dataSimulate?.result">
                  <div id="result-simulation-result-OK_01" class="effort" *ngSwitchCase="'OK_01'">
                    <div class="row date-row">
                      <div class="col-2 no-pd">
                        <span class="ic ic-check"></span>
                      </div>
                      <div class="col-10 no-pd">
                        <p>{{ 'result_sumulation_ok' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="result-simulation-result-MSG_REVIEW_L3_01" class="effort" *ngSwitchCase="'MSG_REVIEW_L3_01'">
                    <div class="row date-row">
                      <div class="col-2 no-pd">
                        <span class="ic ic-info"></span>
                      </div>
                      <div class="col-10 no-pd">
                        <p>{{ 'result_sumulation_ok' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="result-simulation-result-MSG_REVIEW_L3_02" class="effort" *ngSwitchCase="'MSG_REVIEW_L3_02'">
                    <div class="row date-row">
                      <div class="col-2 no-pd">
                        <span class="ic ic-info"></span>
                      </div>
                      <div class="col-10 no-pd">
                        <p>{{ 'result_your_request_reviewed' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="result-simulation-result-MSG_REVIEW_L3_03" class="effort" *ngSwitchCase="'MSG_REVIEW_L3_03'">
                    <div class="row date-row">
                      <div class="col-2 no-pd">
                        <span class="ic ic-info"></span>
                      </div>
                      <div class="col-10 no-pd">
                        <p>{{ 'result_your_request_reviewed' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="result-simulation-result-MSG_REVIEW_L4_01" class="effort" *ngSwitchCase="'MSG_REVIEW_L4_01'">
                    <div class="row date-row">
                      <div class="col-2 no-pd">
                        <span class="ic ic-info"></span>
                      </div>
                      <div class="col-10 no-pd">
                        <p>{{ 'result_sumulation_ok' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="result-simulation-result-MSG_REVIEW_L4_02" class="effort" *ngSwitchCase="'MSG_REVIEW_L4_02'">
                    <div class="row date-row">
                      <div class="col-2 no-pd">
                        <span class="ic ic-info"></span>
                      </div>
                      <div class="col-10 no-pd">
                        <p>{{ 'result_your_request_reviewed' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="result-simulation-result-MSG_REVIEW_L4_03" class="effort" *ngSwitchCase="'MSG_REVIEW_L4_03'">
                    <div class="row date-row">
                      <div class="col-2 no-pd">
                        <span class="ic ic-info"></span>
                      </div>
                      <div class="col-10 no-pd">
                        <p>{{ 'result_your_request_reviewed' | translate }}</p>
                      </div>
                    </div>
                  </div>
                  <div id="result-simulation-result-KO" class="effort ko" *ngSwitchDefault>
                    <div class="row date-row">
                      <div class="col-12">
                        <p>
                          <span class="ic ic-warning"></span>
                          {{ 'result_simularion_ko_reason' | translate }}
                        </p>
                        <ul class="document-list result-error">
                          <li [id]="reason" *ngFor="let reason of dataSimulate?.reasons">
                            {{ 'reasons.' + reason | translate: { minAmount: minAmount | number: '1.2-2' } }}
                          </li>
                        </ul>
                        <p class="indent">{{ 'result_review_data' | translate }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="col-12">
                <div class="row date-row summary">
                  @if (dataSimulate?.mortgageResult?.params?.numMonthsFixed !== '0') {
                    <ng-container>
                      <div class="col-md-2 col-6 text-align-left d-flex">
                        <span>{{
                          'result_tin_n_months'
                            | translate
                              : {
                                  months: dataSimulate?.mortgageResult?.params?.numMonthsFixed
                                    ? dataSimulate?.mortgageResult?.params?.numMonthsFixed
                                    : '-',
                                }
                        }}</span>
                        <a
                          class="icon-a"
                          href="javascript:void(0)"
                          tooltipEvent="focus"
                          appOpenToast
                          id="result-id-tooltip-tin-first-year"
                          [pTooltip]="
                            'tooltip_tin_first_n_months'
                              | translate
                                : {
                                    months: dataSimulate?.mortgageResult?.params?.numMonthsFixed
                                      ? dataSimulate?.mortgageResult?.params?.numMonthsFixed
                                      : '-',
                                  }
                          "
                        >
                          <img class="ico-info" src="assets/img/info.svg" />
                        </a>
                      </div>
                      <div class="col-md-2 col-6 text-align-right">
                        @if (dataSimulate?.mortgageResult?.calculation?.tinY1) {
                          <span id="result-tinY1"
                            >{{ dataSimulate?.mortgageResult?.calculation?.tinY1 | number: '1.2-2' }} %</span
                          >
                        }
                      </div>
                    </ng-container>
                  } @else {
                    <ng-template #tin>
                      <div class="col-md-2 col-6 text-align-left d-flex">
                        <span>{{ 'result_tin' | translate }}</span>
                      </div>
                      <div class="col-md-2 col-6 text-align-right">
                        @if (dataSimulate?.mortgageResult?.calculation?.tin) {
                          <span id="result-tinY1"
                            >{{ dataSimulate?.mortgageResult?.calculation?.tin | number: '1.2-2' }} %</span
                          >
                        }
                      </div>
                    </ng-template>
                  }
                  <div class="col-md-2 col-6 text-align-left">
                    <span class="nowrap">
                      {{ 'result_euribor' | translate }}
                    </span>
                  </div>
                  <div class="col-md-2 col-6 text-align-right">
                    @if (dataSimulate?.mortgageResult?.calculation?.differential) {
                      <span id="result-differential"
                        >+{{ dataSimulate?.mortgageResult?.calculation?.differential | number: '1.2-2' }} %</span
                      >
                    }
                  </div>
                  <div class="col-md-2 col-6 text-align-left">
                    <span>{{ 'result_tae' | translate }}</span>
                  </div>
                  <div class="col-md-2 col-6 text-align-right">
                    @if (dataSimulate?.mortgageResult?.calculation?.tae) {
                      <span id="result-tae"
                        >{{ dataSimulate?.mortgageResult?.calculation?.tae | number: '1.2-2' }} %</span
                      >
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      @if (isSimulation) {
        <div class="form-btn-group col-12 no-pd d-flex justify-content-end">
          <a
            id="result-btn-modify"
            class="btn btn-01"
            routerLink="/dashboard/estudio-economico"
            (click)="
              sendEventGTM({
                event: 'interaccion',
                eAction: 'recogida_de_datos',
                eLabel: 'modificar_hipoteca',
              })
            "
          >
            {{ 'result_btn_modify' | translate }}</a
          >

          @if (dataSimulate && dataSimulate?.result === 'OK_01') {
            <a
              id="result-btn-continue"
              class="btn btn-02"
              href="javascript:void(0)"
              (click)="openModal('beginReview')"
              >{{ 'result_btn_continue' | translate }}</a
            >
          }
        </div>
      }
      <section class="col-12 recipient-info no-pd">
        <h3 class="h-main h-main-medium corporate">
          {{ 'result_request_data' | translate }}
        </h3>
        <div class="col-12 recipient primary-info-box advanced-result">
          <div class="row colapsable">
            <div class="col-12">
              <h3 class="h-sub-section" (click)="collapse('commonData')">
                {{ 'result_general_data' | translate }}
                <a
                  href="javascript:;"
                  [ngClass]="{
                    'ic ic-arrow-short-down': collapseData?.commonData,
                    'ic ic-arrow-short-up': !collapseData?.commonData,
                  }"
                ></a>
              </h3>
              <div class="colapsable-content" [class.visible]="!collapseData?.commonData">
                <div class="row">
                  <div class="col-xl-6 col-12">
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">{{ 'result_num_holders' | translate }}</span>
                      </div>
                      <div class="col-12">
                        <span id="result-num-holders" class="recipient-data">
                          {{ personalData?.level2Data?.holders?.length }}
                        </span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">{{ 'result_expenses_other_loans' | translate }}</span>
                      </div>
                      <div class="col-12">
                        @if (personalData?.level2Data?.expensesOtherLoad !== '') {
                          <span id="result-expensesOtherLoad" class="recipient-data"
                            >{{ personalData?.level2Data?.expensesOtherLoad | number: '1.2-2' }} €</span
                          >
                        }

                        @if (personalData?.level2Data?.expensesOtherLoad === '') {
                          <span id="result-expensesOtherLoad" class="recipient-data">{{ 0 | number: '1.2-2' }} €</span>
                        }
                      </div>
                    </div>
                    <div class="row date-row w-border-mobile">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'result_members_family' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="result-membersFamily" class="recipient-data">
                          {{ personalData?.level2Data?.membersFamily }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-6 col-12">
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'result_postal_code' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="result-postCode" class="recipient-data">{{
                          personalData?.level2Data?.postCode
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">{{ 'result_square_meters' | translate }}</span>
                      </div>
                      <div class="col-12">
                        <span id="result-squareMeters" class="recipient-data">
                          {{ personalData?.level2Data?.squareMeters }}
                        </span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">{{ 'result_signature_date' | translate }}</span>
                      </div>
                      <div class="col-12">
                        @if (personalData?.level2Data?.signatureDate) {
                          <span id="result-signatureDate" class="recipient-data">
                            {{ personalData?.level2Data?.signatureDate | date }}
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="divider" />
          </div>
          <div class="row colapsable">
            <div class="col-12" *ngFor="let holder of personalData?.level2Data?.holders; let indice = index">
              <div class="col-12">
                <h3 class="h-sub-section" (click)="collapseHolder(holder)">
                  {{ holder?.name }} {{ holder?.firstSurname }}
                  {{ holder?.secondSurname }}
                  <a
                    href="javascript:;"
                    [ngClass]="{
                      'ic ic-arrow-short-down': !holder['isVisible'],
                      'ic ic-arrow-short-up': holder['isVisible'],
                    }"
                  ></a>
                </h3>
                <div class="colapsable-content" [class.visible]="holder['isVisible']">
                  <div class="row">
                    <h4 class="col-12 h-title">
                      {{ 'result_personal_data' | translate }}
                    </h4>
                    <div class="col-xl-6 col-12">
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_name' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-name'" class="recipient-data">{{
                            holder?.name
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_surname' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-firstSurname'" class="recipient-data">{{
                            holder?.firstSurname
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_second_surname' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-secondSurname'" class="recipient-data">{{
                            holder?.secondSurname
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_document_type' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-idType'" class="recipient-data">{{
                            holder?.idType | translate
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row w-border">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_id_number' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-idNumber'" class="recipient-data">{{
                            holder?.idNumber
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row w-border-mobile">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_country' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-country'" class="recipient-data">{{
                            holder?.country
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-6 col-12">
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_birthday' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-birthDate'" class="recipient-data"
                            >{{ holder?.birthDate | date }}
                          </span>
                        </div>
                      </div>
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_email' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-email'" class="recipient-data"
                            >{{ holder?.email }}
                          </span>
                        </div>
                      </div>
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_marital_status' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-maritalStatus'" class="recipient-data">{{
                            holder?.maritalStatus | translate
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row w-border">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_phone' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-phone'" class="recipient-data">{{
                            holder?.phone
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row w-border">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_gender' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-gender'" class="recipient-data">{{
                            holder?.gender ? ('result_gender_' + holder?.gender | translate) : ''
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row w-border-mobile">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_nationality' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-nationality'" class="recipient-data">{{
                            holder?.nationality
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <hr class="divider" />
                    <h4 class="col-12 h-title">
                      {{ 'result_address' | translate }}
                    </h4>
                    <div class="col-12">
                      <div class="row date-row">
                        <div class="col-12">
                          @if (holder?.holderAddress.roadType && holder?.holderAddress.roadName) {
                            <span class="recipient-data">
                              {{ holder?.holderAddress.roadType | translate }} &nbsp;{{
                                holder?.holderAddress.roadName
                              }},
                            </span>
                          }

                          @if (holder?.holderAddress.roadNumber) {
                            <span class="recipient-data">&nbsp;nº {{ holder?.holderAddress.roadNumber }}</span>
                          }

                          @if (holder?.holderAddress.doorway) {
                            <span class="recipient-data">&nbsp;portal {{ holder?.holderAddress.doorway }}&nbsp; </span>
                          }
                          <span class="recipient-data">{{ holder?.holderAddress.floor }}&nbsp;</span>
                          <span class="recipient-data">{{ holder?.holderAddress.door }}&nbsp;</span>
                          <span class="recipient-data">{{ holder?.holderAddress.zip }}&nbsp;</span>
                          <span class="recipient-data">{{ holder?.holderAddress.city }}</span>
                        </div>
                      </div>
                    </div>
                    <hr class="divider" />
                    <h4 class="col-12 h-title">
                      {{ 'result_economic_data' | translate }}
                    </h4>
                    <div class="col-xl-6 col-12">
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_monthly_income' | translate }}</span>
                        </div>
                        <div class="col-12">
                          @if (holder?.holderEmploymentData?.monthlyIncome) {
                            <span [id]="'result-holder' + (indice + 1) + '-monthlyIncome'" class="recipient-data"
                              >{{ holder?.holderEmploymentData?.monthlyIncome | number: '1.2-2' }} €</span
                            >
                          }
                        </div>
                      </div>
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_other_income' | translate }}</span>
                        </div>
                        <div class="col-12">
                          @if (holder?.holderEmploymentData?.otherIncome !== '') {
                            <span [id]="'result-holder' + (indice + 1) + '-otherIncome'" class="recipient-data"
                              >{{ holder?.holderEmploymentData?.otherIncome | number: '1.2-2' }} €</span
                            >
                          }

                          @if (holder?.holderEmploymentData?.otherIncome === '') {
                            <span [id]="'result-holder' + (indice + 1) + '-otherIncome'" class="recipient-data"
                              >{{ 0 | number: '1.2-2' }} €</span
                            >
                          }
                        </div>
                      </div>
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_employement_situation' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-employmentSituation'" class="recipient-data">{{
                            holder?.holderEmploymentData?.employmentSituation | translate
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row w-border-mobile">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_academic_level' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-academic-level'" class="recipient-data">{{
                            holder?.holderEmploymentData?.academicLevel | translate
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-6 col-12">
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_company_name' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-companyName'" class="recipient-data">{{
                            holder?.holderEmploymentData?.companyName
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_seniority_company' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-laborSeniority'" class="recipient-data">{{
                            holder?.holderEmploymentData?.laborSeniority | translate
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row w-border">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_activity_sector' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-activity-sector'" class="recipient-data">{{
                            holder?.holderEmploymentData?.activitySector | translate
                          }}</span>
                        </div>
                      </div>
                      <div class="row date-row w-border-mobile">
                        <div class="col-12">
                          <span class="recipient-label">{{ 'result_professional_level' | translate }}</span>
                        </div>
                        <div class="col-12">
                          <span [id]="'result-holder' + (indice + 1) + '-professional-level'" class="recipient-data">{{
                            holder?.holderEmploymentData?.professionalLevel | translate
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              @if (indice === 0 && personalData?.level2Data?.holders?.length > 1) {
                <hr class="divider" />
              }
            </div>
          </div>
        </div>
      </section>
    </div>
    @if (httpError) {
      <div class="dashboard-card status">
        <app-error [isComponent]="false"></app-error>
      </div>
    }
  </div>
}
